var exports = {
  "kL": "xa15a2ab7--3ee144--container",
  "W2": "xa15a2ab7--3ee144--scroll",
  "Sl": "xa15a2ab7--3ee144--image",
  "UE": "xa15a2ab7--3ee144--arrow",
  "m0": "xa15a2ab7--3ee144--arrow-left",
  "tS": "xa15a2ab7--3ee144--arrow-right",
};

module.exports = exports;
